const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/students",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      options["branch"] = rootState.aljabr.selectedBranch._id;
      options["academicYear"] = rootState.aljabr.selectedAcademicYear._id;
      options["company"] = rootState.company._id;
      options["short"] = rootState.company.short.toLowerCase();
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    list({ dispatch, state, rootState }, options) {
      options["branch"] = rootState.aljabr.selectedBranch._id;
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/list?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    check({ dispatch, state, rootState }, value) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/check/${value}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    add({ dispatch, state, rootState }, data) {
      data["branch"] = rootState.aljabr.selectedBranch._id;
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    id({ dispatch, state, rootState }, value) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/id/${value}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    update({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    setGender({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/set-gender`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    updateParents({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update-parents`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    sendMessageToParent({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-message-to-parent`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    studentVisits({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/visits/${options.id}?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    listForAddGroup({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/list-for-add-group?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    addStudentToGroup({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-student-to-group`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    changeBranchAndAcademicYear({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/change-branch-and-academic-year`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    parentBotId({ dispatch, state, rootState }, telegramID) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/parent-bot-id?telegramID=${telegramID}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    updateByBirthCertificate({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update-by-birth-certificate`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getOptionalLessons({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/optional-lessons?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    parentsById({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/parents-by-id?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    removeContractFromStudent({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/remove-contract-from-student`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getCertificates({ dispatch, state, rootState }, studentId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/certificate-pdf?studentId=${studentId}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    setStarterKnowledge({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/set-starter-knowledge`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getMaterials({ dispatch, state }, { studentId, academicYear }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/materials/${studentId}?academicYear=${academicYear || ""}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    assignMaterials({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/assign-materials`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    uploadGivenAct({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/upload-given-act`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    uploadReturnAct({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/upload-return-act`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getMaterialFile({ dispatch, state }, { studentId, academicYear, type }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/material-act-file/${studentId}?academicYear=${academicYear || ""}&type=${type || "given"}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
  },
};
